import "./BillOfMaterialsList.css";
import React, { useEffect, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { useDataLayerValue } from "../../../App/reducer/DataLayer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCookies } from "react-cookie";
import {
  faSearch,
  faInfoCircle,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";

import Loading from "../../../App/components/Loading/Loading";
import TableHeader from "../../../App/components/shared/TableHeader";
import fetch_backend from "../../../App/components/shared/Fetch";
import StatusBadge from "../../../App/components/shared/StatusBadge";
import { ModalQuestion, ModalForm } from "../../../App/components/shared/Modals";
import { url_bill_of_materials } from "../../constants/constants";

function BillOfMaterialsList() {
  const history = useHistory();
  const { path } = useRouteMatch();
  const [{ actual_url }, dispatch] = useDataLayerValue();
  const [sortAscen, setSortAscen] = useState();
  const [clicked_column, setClicked_column] = useState("");
  const [json_response, setJson_response] = useState();
  const [backupJson_response, setBackupJson_response] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [includeFinished, setIncludeFinished] = useState(false);
  const [cookies] = useCookies();
  const token = cookies.token_orders;

  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);
  const [bomToDelete, setBomToDelete] = useState(null);
  const [openModalForm, setOpenModalForm] = useState(false);
  const [successModalForm, setSuccessModalForm] = useState(false);
  const [messageModalForm, setMessageModalForm] = useState([]);

  // El backend ya excluye las hojas finalizadas del listado principal y dice
  // cuántas dejó fuera en hidden_finished. Aquí no se filtra nada.
  async function send_init_request(withFinished = false) {
    setIsLoading(true);
    var response = await fetch_backend(
      withFinished ? "bill_materials/?include_finished=1" : "bill_materials/",
      "GET",
      token,
      dispatch
    );
    setJson_response(response);
    setBackupJson_response(response);
    setIsLoading(false);
  }

  const toggleFinished = () => {
    const next = !includeFinished;
    setIncludeFinished(next);
    send_init_request(next);
  };

  const click_column = (col_name) => {
    setClicked_column(col_name);
  };

  function isNumeric(x) {
    let value = !isNaN(x) ? x : parseFloat(x.replace(/[\$,]/g, ""));
    return { isNum: !isNaN(value), value };
  }

  const sortFunction = (sub) => {
    setSortAscen(!sortAscen);
    const list = [...json_response.bill_materials];
    let nulls = list.filter((item) => item[sub] == null);
    let empty_str = list.filter((item) => item[sub] === "");
    let toSort = list.filter((item) => item[sub]);
    let sorted = toSort.sort((a, b) => {
      let aa = isNumeric(a[sub]);
      let bb = isNumeric(b[sub]);
      if (aa.isNum && bb.isNum) {
        return aa.value - bb.value;
      }
      return a[sub].toString().toLowerCase() > b[sub].toString().toLowerCase()
        ? 1
        : -1;
    });
    sorted = sorted.concat(nulls).concat(empty_str);
    if (!sortAscen) {
      sorted.reverse();
    }
    setJson_response({ ...json_response, bill_materials: sorted });
  };

  const handleSearch = (value) => {
    let newList = [...backupJson_response.bill_materials];
    if (value !== "") {
      const search = value.toLowerCase();
      newList = newList.filter(
        (row) =>
          (row.user_code &&
            row.user_code.toLowerCase().includes(search)) ||
          (row.client_name &&
            row.client_name.toLowerCase().includes(search)) ||
          (row.id && row.id.toString().includes(value)) ||
          (row.quote_id &&
            row.quote_id.toString().toLowerCase().includes(search)) ||
          (row.name &&
            row.name.toLowerCase().includes(search))
      );
      setJson_response({ ...json_response, bill_materials: newList });
    } else {
      setJson_response(backupJson_response);
    }
  };

  const onFocusSearch = () => {
    setBackupJson_response(json_response);
  };

  const click_bom_detail = (row) => {
    history.push(`${url_bill_of_materials}/detail`, {
      // internal_status es lo que antes significaba status === "draft":
      // la elección del usuario. status ahora describe la cotización.
      is_edit: row.internal_status === "draft",
      is_new: false,
      bom_id: row.id,
    });
  };

  const click_new_bom = () => {
    history.push(`${url_bill_of_materials}/detail`, {
      is_edit: false,
      is_new: true,
      bom_id: null,
    });
  };

  const click_delete_bom = (row) => {
    setBomToDelete(row.id);
    setOpenDeleteConfirmation(true);
  };

  const callback_delete_bom = async ({ value, params }) => {
    setOpenDeleteConfirmation(false);
    if (value !== "true") return;

    setIsLoading(true);
    const response = await fetch_backend(
      `bill_materials/${params}/`,
      "DELETE",
      token,
      dispatch
    );
    setIsLoading(false);

    if (response.status === 200 || response.status === 204) {
      const newList = json_response.bill_materials.filter(
        (item) => item.id !== params
      );
      setJson_response({ ...json_response, bill_materials: newList });
      setBackupJson_response({
        ...backupJson_response,
        bill_materials: backupJson_response.bill_materials.filter(
          (item) => item.id !== params
        ),
      });
      setSuccessModalForm(true);
      setMessageModalForm(["Hoja de costos eliminada correctamente"]);
    } else {
      setSuccessModalForm(false);
      setMessageModalForm(["No se pudo eliminar la hoja de costos"]);
    }
    setOpenModalForm(true);
    setBomToDelete(null);
  };

  useEffect(() => {
    dispatch({
      type: "SET_URL",
      actual_url: url_bill_of_materials,
    });
    send_init_request();
  }, []);

  return (
    <div className="wrapped__container_top_bar bom-list-view">
      <Loading isLoading={isLoading} />

      <div className="top-bar">
        <h3>Hojas de Costos</h3>
      </div>

      <div className="search_div">
        <div className="search_container" style={{ flex: 0.5 }}>
          <input
            type="text"
            onChange={(event) => handleSearch(event.target.value)}
            onFocus={() => onFocusSearch()}
            placeholder="Buscar por código, cliente, ID o cotización..."
          />
          <FontAwesomeIcon icon={faSearch} color="#383838" />
        </div>
        {(includeFinished || json_response?.hidden_finished > 0) && (
          <button className="bom-list-finished-link" onClick={toggleFinished}>
            {includeFinished
              ? "Ocultar finalizadas"
              : `Ver ${json_response.hidden_finished} ${
                  json_response.hidden_finished === 1
                    ? "finalizada"
                    : "finalizadas"
                }`}
          </button>
        )}
        <div className="guides_tools" style={{ display: "flex", justifyContent: "flex-end", marginRight: "16px" }}>
          <div className="sub_guide_tools">
            <div
              className="square_agregar_tools"
              onClick={click_new_bom}
            >
              <p className="col_white agregar_label_btn">
                <FontAwesomeIcon icon={faPlus} style={{ marginRight: "6px" }} />
                Nueva Hoja de Costos
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="task-content">
        <table className="table_tasks">
          <thead>
            <tr className="rowHeaders">
              <th style={{ width: "10%" }}>Estado</th>
              <TableHeader
                sortFunction={sortFunction}
                sortAscen={sortAscen}
                click_column={click_column}
                clicked_column={clicked_column}
                col_name="Analista"
                txt_filter="user_code"
                width="12%"
              />
              <TableHeader
                sortFunction={sortFunction}
                sortAscen={sortAscen}
                click_column={click_column}
                clicked_column={clicked_column}
                col_name="Id"
                txt_filter="id"
                width="8%"
              />
              <TableHeader
                sortFunction={sortFunction}
                sortAscen={sortAscen}
                click_column={click_column}
                clicked_column={clicked_column}
                col_name="Cliente"
                txt_filter="client_name"
                width="18%"
              />
              <TableHeader
                sortFunction={sortFunction}
                sortAscen={sortAscen}
                click_column={click_column}
                clicked_column={clicked_column}
                col_name="Cotización"
                txt_filter="quote_id"
                width="9%"
              />
              <TableHeader
                sortFunction={sortFunction}
                sortAscen={sortAscen}
                click_column={click_column}
                clicked_column={clicked_column}
                col_name="Nombre"
                txt_filter="name"
                width="15%"
              />
              <th style={{ width: "13%" }}>Tags</th>
              <TableHeader col_name="Detalle" width="8%" />
              <TableHeader col_name="Eliminar" width="8%" />
            </tr>
          </thead>
          <tbody>
            {json_response?.bill_materials?.map((row, index) => (
              <tr className="rowTasks" key={row.id || index}>
                <td>
                  <StatusBadge color={row.color} label={row.status_label} />
                </td>
                <td>{row.user_code}</td>
                <td>{row.id}</td>
                <td>{row.client_name}</td>
                <td>{row.quote_id}</td>
                <td>{row.name}</td>
                <td>
                  <div className="bom-list-tags-cell">
                    {row.tags?.map((tag, i) => (
                      <span className="bom-list-tag-badge" key={i}>
                        {tag}
                      </span>
                    ))}
                  </div>
                </td>
                <td>
                  <FontAwesomeIcon
                    icon={faInfoCircle}
                    color="#383838"
                    className="iconRow"
                    onClick={() => click_bom_detail(row)}
                  />
                </td>
                <td>
                  <FontAwesomeIcon
                    icon={faTrash}
                    color="#F44336"
                    className="iconRow"
                    onClick={() => click_delete_bom(row)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {json_response && json_response.bill_materials?.length === 0 && (
          <div className="bom-list-empty">
            <p>No hay hojas de costos creadas.</p>
            <button className="bom-list-empty-btn" onClick={click_new_bom}>
              <FontAwesomeIcon icon={faPlus} style={{ marginRight: "6px" }} />
              Crear Nueva Hoja de Costos
            </button>
          </div>
        )}
      </div>

      <ModalQuestion
        open={openDeleteConfirmation}
        onClose={() => setOpenDeleteConfirmation(false)}
        question="¿Está seguro que desea eliminar esta hoja de costos?"
        callback={callback_delete_bom}
        params={bomToDelete}
      />

      <ModalForm
        open={openModalForm}
        onClose={() => setOpenModalForm(false)}
        successModal={successModalForm}
        messageModal={messageModalForm}
      />
    </div>
  );
}

export default BillOfMaterialsList;
